import { Box, Container, Divider, Text } from "@mantine/core";
import React from "react";
import { IconLogoBW } from "./IconLogoBW";
import { data, description } from "./data";
import * as classes from "./index.module.css";

export default function SiteFooter() {
  const groups = data.map((group) => {
    const links = group.links.map((link, index) => (
      <Text<"a">
        key={index}
        className={classes.link}
        component="a"
        href={link.link}
        onClick={(event) => event.preventDefault()}
      >
        {link.label}
      </Text>
    ));

    return (
      <div className={classes.wrapper} key={group.title}>
        <Text className={classes.title}>{group.title}</Text>
        <Divider my="md" />
        {links}
      </div>
    );
  });

  return (
    <footer className={classes.footer}>
      <Container className={classes.inner}>
        <div className={classes.logo}>
          <IconLogoBW />
          <Text size="sm" c="white" className={classes.description}>
            {description}
          </Text>
        </div>
        <div className={classes.groups}>{groups}</div>
      </Container>
      <Box className={classes.afterFooter}>
        <Text c="white" size="sm" ta="center">
          Copyright © 2024 Hui One Capital Sdn Bhd.
        </Text>
      </Box>
    </footer>
  );
}
